import Base64 from "crypto-js/enc-base64";
import Utf8 from "crypto-js/enc-utf8";

export const urlSafeBase64 = (value: string) => {
  return convertBase64ToUrlSafe(Utf8.parse(value).toString(Base64));
};

export const convertBase64ToUrlSafe = (value: string) => {
  return value.replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
};
